import React, { useState } from 'react'
import TaskItem from './TaskItem'

const TaskList = ({ tasks, onEdit, onShare, onDelete, onTaskUpdate }) => {
  const [openTaskIds, setOpenTaskIds] = useState(new Set())

  const toggleTaskOpen = (taskId) => {
    const newOpenTasks = new Set(openTaskIds)
    if (newOpenTasks.has(taskId)) {
      newOpenTasks.delete(taskId)
    } else {
      newOpenTasks.add(taskId)
    }
    setOpenTaskIds(newOpenTasks)
  }

  return (
    <div className="task-row">
      {tasks.map(task => (
        <TaskItem
          key={task.id}
          task={task}
          isOpen={openTaskIds.has(task.id)}
          onToggleOpen={() => toggleTaskOpen(task.id)}
          onEdit={onEdit}
          onShare={onShare}
          onDelete={onDelete}
          onTaskUpdate={onTaskUpdate}
        />
      ))}
    </div>
  )
}

export default TaskList